<template>
    <main>
       <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                     <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                     </div>
                     <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit Budget Head</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/BudgetHeads/MenuList.vue";
    import lang from "@/views/modules/BudgetHeads/language/en";
    import GenericEdit from "@/components/layout/shared/generic/EditView.vue";

    export default {
        name: "new-budgetheads",
        components: {
            breadcrumbs,
            GenericEdit,
        },
        data() {
            return {
                generic: true,
                metaList: [
                    {
                        type: 'text',
                        name: 'name',
                        label: lang.LBL_BUDGETHEAD_NAME,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'head_sequence',
                        label: lang.LBL_BUDGETHEAD_SEQUENCE,
                        required: true
                    },
                    {
                        type: 'selectbox',
                        name: 'status',
                        label: lang.LBL_STATUS,
                        required: false,
                        items: [
                            { value: 'Active' },
                            { value: 'Inactive' },
                        ],
                    },
                    {
                    type:'checkbox',
                    name:'is_monthly',
                    label: lang.LBL_IS_MONTHLY,
                    value:'Yes',
                    required: false
                    },
                   
                ],

                urls: 'api/modules/budgetheads',

                routePath: {
                    path: 'budgetheads',
                    detail: false
                }
            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>